import React,{Component} from "react";
import { connect } from "react-redux";
import { Alert, Modal, ModalHeader,ModalBody } from 'reactstrap';
import Form from "./Form";
import Actions from "../../../../Actions";
import Tile from "../../Layout/Tile";

class SubLocationAdd extends Component{
    constructor(props){
        super(props);
        this.alertRef = false;
    }

    componentDidUpdate(){
        const {locationStore: { alert: { subLocations_alert: add } } } = this.props;
        if(add && this.modalRef ) this.modalRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });

    }
    render = () => {
        const { locationStore: { alert: { subLocations_alert: add } }, modalStore: { add: { modal, data: { location_id = false } }}, addSubLocation, toggleModal } = this.props;
        return (
            <div>
                <Modal size="lg" isOpen={modal} keyboard={false} toggle={() => toggleModal("subLocations","add")}>
                    <ModalHeader toggle={() => toggleModal("subLocations","add")}>Add Sub Location</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                {add !== false &&
                                    <Alert color={add.type}>
                                        { add.message }
                                    </Alert>                                         
                                }
                                <Form data={{location_id}} persist={addSubLocation} />
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locationStore: state.locationStore,
    modalStore: state.modalStore.subLocations,
});

const { locations, modals } = Actions;

export default connect(mapStateToProps, { ...locations, ...modals })(SubLocationAdd);


// WEBPACK FOOTER //
// ./src/Components/App/Locations/SubLocations/Add.js